import { useAct } from 'FlowBuilder/store'
import Select from 'react-select';
import Checkbox from 'Shared/components/Checkbox'
import './SurveyPageForm.scoped.scss'
import SubscriptionTopicsSelect from 'Shared/components/SubscriptionTopicsSelect'
import useQuestionTranslate from 'FlowBuilder/hooks/useQuestionTranslate';

export default function QuestionSetting({ question, setting }) {
  const act = useAct()
  const { key, label, type, options } = setting
  const settings = question.settings || {}
  const value = settings[key]

  function setSetting(key, value) {
    act.questions.upsertSettings(question.id, { [key]: value })
  }

  const {
    language,
    translated: { [key]: translatedValue },
    fallback: { [key]: translatedValueFallback },
    textContentUpdater,
    flag
  } = useQuestionTranslate({ questionId: question.id });

  const selectOptions = options ? options.map(o => ({ value: o.value, label: o.label })) : []

  return <div className='field'>
    {type === 'text' && <>
      <label>{label} {flag}</label>
      <input type='text' value={translatedValue ?? ''} onChange={(e) => textContentUpdater(key, e.target.value)} placeholder={translatedValueFallback ?? (setting.placeholder ?? '')} />
    </>
    }

    {type === 'multi_select' && <>
      <label>{label}</label>
      <Select isMulti options={selectOptions} value={selectOptions.filter(o => _.includes(value, o.value))} onChange={o => setSetting(key, o.map(x => x.value))} />
    </>
    }

    {type === 'subscription_topics_select' && <>
      <label>{label}</label>
      <SubscriptionTopicsSelect isMulti documentPortalTarget={false} value={value} onChange={o => setSetting(key, o.map(x => x.value))} />
    </>
    }

    {type === 'checkbox' && <>
      <Checkbox label={label} checked={!!value} onChange={e => setSetting(key, e.target.checked)} />
    </>
    }

    {type === 'checkbox_and_message' &&
      <Checkbox label={label} checked={value} onChange={e => setSetting(key, e.target.checked)} />
    }

    {type === 'text_opt_out' && settings.optOutPrompt === true &&
      <div className='field flex-center gap-10'>
        <label>{label} {flag}</label>
        <input className="grow" type='text' value={translatedValue ?? ''} onChange={(e) => textContentUpdater(key, e.target.value)} placeholder={translatedValueFallback ?? ''} />
      </div>
    }

    {type === 'number' && 
      <div className='field flex-center gap-10 margin-top'>
        <label>{label}</label>
        <input type='number' value={value ?? ''} onChange={(e) => setSetting(key, e.target.value ? parseInt(e.target.value) : null)} placeholder={setting.placeholder ?? ''} />
      </div>
    }

    {type === 'number_max_answers' && settings.enableMaxAnswers === true && <>
      <label>{label}</label>
      <input type='number' value={value ?? ''} onChange={(e) => setSetting(key, e.target.value ? parseInt(e.target.value) : null)} placeholder={setting.placeholder ?? ''} />
    </>
    }
  </div>
}